import request from './request.js';

const LoginRequest = (params) => {
  return request({
    method: "POST",
    data: params,
    url: "/auth/password"
  })
}

const LogoutRequest = () => {
  return request({
    method: "GET",
    url: "/logout"
  })
}

const getUser = () => {
  return request({
    method: 'GET',
    url: '/user/me'
  })
}

const getSubscriptionType = () => {
  return request({
    method: 'GET',
    url: '/constant/type/subscription'
  })
}

const updatePassword = (params) => {
  return request({
    method: 'PATCH',
    data: params,
    url: '/user/password'
  })
}

const getSubscriptions = (params) => {
  return request({
    method: 'POST',
    data: params,
    url: '/user/subscription/page'
  })
}

const getSXWYYear = (nowYear, year) => {
  return request({
    method: 'GET',
    url: '/SXWY/year?nowYear=' + nowYear + '&year=' + year
  })
}

const getSXWYShengxiaoNianMapping = (params) => {
  return request({
    method: 'POST',
    data: params,
    url: '/SXWY/shengxiaoNianMapping'
  })
}

const getSXWYZS = (shengxiao) => {
  return request({
    method: 'GET',
    url: '/SXWY/zhongsheng?shengxiao=' + shengxiao
  })
}

const getLZCJCheck = (date) => {
  return request({
    method: 'GET',
    url: '/LZCJ/check?date=' + date
  })
}

const getLZCJ = (date) => {
  return request({
    method: 'GET',
    url: '/LZCJ?date=' + date
  })
}

export {
  LoginRequest, LogoutRequest, getLZCJ, getLZCJCheck, getSXWYShengxiaoNianMapping, getSXWYYear, getSXWYZS,
  getSubscriptionType, getSubscriptions, getUser, updatePassword
};

